import React from 'react';
import './App.css';
import '../../assets/css/onedark.css';
import '../../assets/scss/social-links.scss'

import { motion } from 'framer-motion/dist/framer-motion'

import {makeStyles} from "@material-ui/core/styles";
import {
  IntroCard,
  LangCard,
  SocialCard,
  ProjectCard
} from './cards.js';


function App() {

  const [card1, setCard1] = React.useState(1)
  const [card2, setCard2] = React.useState(-2)
  const [card3, setCard3] = React.useState(-1)
  const [card4, setCard4] = React.useState(0)



  document.body.dataset.page = "home"

  const handleOnClick = ()=>{
    if(card1==2){
      setCard1(-1);
    }else{
      setCard1(card1+1);
    }

    if(card2==2){
      setCard2(-1);
    }else{
      setCard2(card2+1);
    }

    if(card3==2){
      setCard3(-1);
    }else{
      setCard3(card3+1);
    }

    if(card4==2){
      setCard4(-1);
    }else{
      setCard4(card4+1);
    }

  }

  const states = {
    "-3": "",
    "-2": "",
    "-1": "",
    "0": " followed",
    "1": " front",
    "2": " fall"
  }

  const links = {
    "github" : "https://github.com/Ivan-Corporation",
    "twitter" : "https://twitter.com/KomaHuman"
  }



  const useStyles = makeStyles((theme) => ({
    background: {
      background: "#fff",    
  },


  
  }));
  
  
  const classes = useStyles();



  return (
    <div >
      
      <div className="intro">
      <motion.div
                initial={{ opacity: 0, y: -180 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                    ease: "easeInOut",
                    duration: 1,
                }}
                >
        <div className="introCards" onClick={handleOnClick}>
          <IntroCard count={0} curState={states[card1]}/>
          <ProjectCard count={1} curState={states[card2]}/>
          <SocialCard count={2} curState={states[card3]}/>
          <LangCard count={3} curState={states[card4]}/>
        </div>
        </motion.div>
        
      </div>
      <motion.div
                initial={{ opacity: 0, x: -180, y: 280 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                    ease: "easeInOut",
                    duration: 1,
                    delay:0.5
                }}
                >
   
      <ul className='soclinks'>
            <li>
              <a href="https://github.com/Ivan-Corporation" target='_blank' className="github"><span><b>Github</b></span><i className="fa fa-github fa-2x" aria-hidden="true"></i></a>
            </li>
            <li>
              <a href="https://www.t.me/KomarIvan" target='_blank' className="telegram"><span><b>Telegram</b></span><i className="fa fa-telegram fa-2x" aria-hidden="true"></i></a>
            </li>
            <li>
              <a href="https://twitter.com/KomaHuman" target='_blank' className="twitter"><span><b>Twitter</b></span><i className="fa fa-twitter fa-2x" aria-hidden="true"></i></a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCWj8NJUnyji2xHHThU1TTsw" target='_blank' className="youtube"><span><b>Youtube</b></span><i className="fa fa-youtube fa-2x" aria-hidden="true"></i></a>
            </li>
          </ul>
      
          </motion.div>

    </div>

    
  )
}

export default App;
